const enableSdkButtons = ({
  bookAppointment = true,
  directCall = true,
  showSplash = true,
  startCall = true
}: {
  startCall: boolean;
  showSplash: boolean;
  directCall: boolean;
  bookAppointment: boolean;
}) => {
  try {
    const startCallElement = document.querySelector<HTMLButtonElement>('[data-conferwith="startCall"]');
    if (startCallElement) {
      startCallElement.disabled = !startCall;
    }

    const showSplashCallElement = document.querySelector<HTMLButtonElement>('[data-conferwith="showSplash"]');
    if (showSplashCallElement) {
      showSplashCallElement.disabled = !showSplash;
    }

    const directCallElement = document.querySelector<HTMLButtonElement>('[data-conferwith="directCall"]');
    if (directCallElement) {
      directCallElement.disabled = !directCall;
    }

    const bookAppointmentElement = document.querySelector<HTMLButtonElement>('[data-conferwith="bookAppointment"]');
    if (bookAppointmentElement) {
      bookAppointmentElement.disabled = !bookAppointment;
    }
  } catch (e) {
    console.error(e);
  }
};
export default enableSdkButtons;
